import type {
  ProductsAllRequest,
  ProductsCollectionRequest,
  ProductsByIdsRequest,
  ProductsBySkusRequest,
  TopRankedProductsRequest,
  ProductsCollectionCompetitorRequest,
  ProductBrowseRequest,
  ProductsDetailRequest,
  ProductMetaRequest,
  ProductIngredientsRequest,
  ProductSearchRequest,
  ListRecommendationsRequest,
  AIInsightRequest,
  QueryListRecommendationsRequest,
  ProductsRecommendRequest,
  RoutineRecommendationsRequest,
} from './types';

export const PRODUCT_QUERY_KEYS = {
  default: () => ['products'] as const,
  list: (params?: string) => [...PRODUCT_QUERY_KEYS.default(), 'list', params] as const,
  all: (params?: ProductsAllRequest) => [...PRODUCT_QUERY_KEYS.default(), 'all', params] as const,
  collections: (params?: ProductsCollectionRequest) =>
    [...PRODUCT_QUERY_KEYS.default(), 'collections', params] as const,
  competitorCollections: (params?: ProductsCollectionCompetitorRequest) =>
    [...PRODUCT_QUERY_KEYS.default(), 'collections', params] as const,
  byIds: (params: ProductsByIdsRequest) => [...PRODUCT_QUERY_KEYS.default(), 'byIds', params] as const,
  bySkus: (params: ProductsBySkusRequest) => [...PRODUCT_QUERY_KEYS.default(), 'bySkus', params] as const,
  topRanked: (params?: TopRankedProductsRequest) => [...PRODUCT_QUERY_KEYS.default(), 'topRanked', params] as const,
  taxonomy: () => [...PRODUCT_QUERY_KEYS.default(), 'taxonomy'] as const,
  brandTaxonomy: () => [...PRODUCT_QUERY_KEYS.default(), 'brandTaxonomy'] as const,
  categoryTaxonomy: () => [...PRODUCT_QUERY_KEYS.default(), 'categoryTaxonomy'] as const,
  allCategoryTaxonomy: () => [...PRODUCT_QUERY_KEYS.default(), 'allCategoryTaxonomy'] as const,
  browse: (params?: ProductBrowseRequest) => [...PRODUCT_QUERY_KEYS.default(), 'browse', params] as const,
  detail: (params: ProductsDetailRequest) => [...PRODUCT_QUERY_KEYS.default(), 'byId', params] as const,
  byIdMeta: (params: ProductMetaRequest) => [...PRODUCT_QUERY_KEYS.default(), 'byIdMeta', params] as const,
  byIdIngredients: (params: ProductIngredientsRequest) =>
    [...PRODUCT_QUERY_KEYS.default(), 'byIdIngredients', params] as const,
  search: (params?: ProductSearchRequest) => [...PRODUCT_QUERY_KEYS.default(), 'search', params] as const,
  recommendations: (params: QueryListRecommendationsRequest) =>
    [...PRODUCT_QUERY_KEYS.default(), 'recommendations', params] as const,
  aiInsight: (params: AIInsightRequest) => [...PRODUCT_QUERY_KEYS.default(), 'aiInsight', params] as const,
  recommend: (params: ProductsRecommendRequest) => [...PRODUCT_QUERY_KEYS.default(), 'recommend', params] as const,
  routineRecommendations: (params: RoutineRecommendationsRequest) =>
    [...PRODUCT_QUERY_KEYS.default(), 'routineRecommendations', params] as const,
};
